import { render, staticRenderFns } from "./p5HelpAndSupport.vue?vue&type=template&id=5e94d0a9"
import script from "./p5HelpAndSupport.vue?vue&type=script&lang=js"
export * from "./p5HelpAndSupport.vue?vue&type=script&lang=js"
import style0 from "./p5HelpAndSupport.vue?vue&type=style&index=0&id=5e94d0a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports